var ui = {};

var constants = require('./lib-constants');

/**
 *  ScrollTo functionnality
 */
ui.smoothScroll = require('./lib-ui-scroll');

/**
 * Utility methods that returns 'true' or 'false' based on the device
 */
ui.isMobile = function() {
  return window.innerWidth < constants.breakpointSm;
};
ui.isTablet = function() {
  return window.innerWidth < constants.breakpointMd && window.innerWidth >= constants.breakpointSm;
};
ui.isDesktop = function() {
  return window.innerWidth >= constants.breakpointMd;
};

ui.isIos = function() {
  return navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false;
}


/**
 * Disable a {jQuery, Node, NodeList} element.
 * - Add a 'disabled' class
 * - Set 'disabled' property to TRUE
 */
ui.disable = function(element) {

  if (!element) return;

  else if (element instanceof jQuery) {

    element.addClass('disabled');
    element.prop('disabled', true);

  } else if (element instanceof Node) {

    element.classList.add('disabled');
    element.disabled = true;

  } else if (element instanceof NodeList) {

    [].forEach.call(element, function(elt) {
			elt.classList.add('disabled');
			elt.disabled = true;
		});

  }
}
/**
 * Enable a {jQuery, Node, NodeList} element.
 * - Remove 'disabled' class
 * - Set 'disabled' property to FALSE
 */
ui.enable = function(element) {

  if (!element) return;

  else if (element instanceof jQuery) {

    element.removeClass('disabled');
    element.prop('disabled', false);

  } else if (element instanceof Node) {

    element.classList.remove('disabled');
    element.disabled = false;

  } else if (element instanceof NodeList) {

    [].forEach.call(element, function(e) {
			e.classList.remove('disabled');
			e.disabled = false;
		});

  }
}

/**
 * Display a loader on a {jQuery, Node, NodeList} element
 * - Add a 'loading' class
 */
ui.displayLoader = function(element) {

  if (!element) return;

  else if (element instanceof jQuery)
    element.addClass('loading');

  else if (element instanceof Node)
    element.classList.add('loading');

  else if (element instanceof NodeList)
    [].forEach.call(element, function(e) { e.classList.add('loading'); });

}
/**
 * Remove loader from a {jQuery, Node, NodeList} element
 * - Remove 'loading' class
 */
ui.hideLoader = function(element) {

  if (!element) return;

  else if (element instanceof jQuery)
    element.removeClass('loading');

  else if (element instanceof Node)
    element.classList.remove('loading');

  else if (element instanceof NodeList)
    [].forEach.call(element, function(e) { e.classList.remove('loading'); });

}

/**
 * CUBE Elements size
 */
ui.size = {
  get header() {
    // select global header
    return window.tc_vars.env_template === 'product'
      ? getHeightHeaderProductPage()
      : getHeightHeader();
  }
};

// Header height -- other than product page
function getHeightHeader () {
  const header = cube.$id('header') || cube.$('.header-checkout');
  return parseInt(header ? header.offsetHeight : 0, 10);
};

// Header height -- specific for product page
function getHeightHeaderProductPage () {
  const productHead = cube.$id('product-head');
  const productHeadHeight = productHead ? productHead.offsetHeight : 0;

  const internalNavigation = cube.$id('internal-navigation');
  const internalNavigationHeight = internalNavigation
    ? internalNavigation.offsetHeight
    : 0;

  return parseInt(productHeadHeight + internalNavigationHeight, 10);
};

module.exports = ui;



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-ui.js